import '../css/styles.scss'
import Site from '../lib/Site.js'

if (document.body.id !== 'form-builder-form') {
	window._site = new Site()
}
